import { AxiosRequestConfig } from 'axios';

import { ObjectType } from '$app-web/types';
import { ClientError } from '$app-web/utils';

import client from '.';

interface Params {
    endpoint: string;
    data: ObjectType;
    pageParam?: unknown;
    cancelable?: boolean;
    extraAxiosConfig?: AxiosRequestConfig;
}

export function callReactQuery(params: Params) {
    const { endpoint, data, pageParam, cancelable = true, extraAxiosConfig = {} } = params;

    if (typeof endpoint !== 'string') {
        throw new ClientError(`Provided endpoint is not valid. It should be string. endpoint: ${endpoint}`);
    }

    if (cancelable) {
        const abortController = new AbortController();

        const promise = client.callEndpoint(endpoint, data, pageParam, {
            signal: abortController.signal,
            ...extraAxiosConfig,
        }) as unknown as Promise<unknown> & { cancel?: () => void };
        // React Query calls promise.cancel() on unmount/unsubscribe, cancelQueries(), or when a fetch is replaced
        promise.cancel = () => abortController.abort('Cancelled by React Query');
        return promise;
    }

    return client.callEndpoint(endpoint, data, undefined, extraAxiosConfig);
}
